import { FileType } from '../models/file-item.model';

function appendParams(uri: string, params: string | Array<string>): string {
    if (typeof params === 'string') {
        params = [params];
    }

    let insertSeparator = false;
    for (const param of params) {
        if (!param.length) {
            continue;
        }
        uri = `${uri}${insertSeparator ? '|' : ''}${param}`;
        insertSeparator = true;
    }
    return uri;
}

export function getNativeUrlForFile(fileType: FileType, filePath: string, correlationId?: string, fromTemplate?: boolean): string | undefined {
    if (!filePath?.length) {
        return undefined;
    }

    const queryIndex = filePath.lastIndexOf('?');
    if (queryIndex >= 0) {
        // Strip any query params off the canonical url, as it is not needed for launching desktop apps
        filePath = filePath.substring(0, queryIndex);
    }

    let uri: string;
    let params = [!fromTemplate ? 'ofe' : 'nft'];
    switch (fileType) {
        case FileType.Excel:
            if (!fromTemplate) {
                params = ['ofv', 'ofc'];
            }
            uri = 'ms-excel:';
            break;
        case FileType.Word:
            uri = 'ms-word:';
            break;
        case FileType.Visio:
            uri = 'ms-visio:';
            break;
        case FileType.PowerPoint:
            uri = 'ms-powerpoint:';
            break;
        case FileType.OneNote:
            return `onenote:${filePath}`;
        default:
            return undefined;
    }

    // file has to be before the correlationId
    params.push('u', filePath);
    if (correlationId?.length) {
        params.push('f', correlationId);
    }
    return appendParams(uri, params);
}
